export default "/_next/static/chunks/fonts/Montserrat-Medium-latin-c1c7e33f97b23d12c571bc7a76e06077.woff2";